export const countryList = [
  {
    text: "ARMENIA",
    age: 14,
    value: "AR"
  },
  {
    text: "AZERBAIJAN",
    age: 18,
    value: "AZ"
  },
  {
    text: "AUSTRIA",
    age: 14,
    value: "AT"
  },
  {
    text: "BELARUS",
    age: 16,
    value: "BL"
  },
  {
    text: "BELGIUM",
    age: 13,
    value: "BE"
  },
  {
    text: "BULGARIA",
    age: 14,
    value: "BG"
  },
  {
    text: "CZECH REPUBLIC",
    age: 15,
    value: "CZ"
  },
  {
    text: "DENMARK",
    age: 13,
    value: "DK"
  },
  {
    text: "FINLAND",
    age: 13,
    value: "FI"
  },
  {
    text: "FRANCE",
    age: 15,
    value: "FR"
  },
  {
    text: "GEORGIA",
    age: 18,
    value: "GE"
  },
  {
    text: "GERMANY",
    age: 16,
    value: "DE"
  },
  {
    text: "GREECE",
    age: 15,
    value: "GR"
  },
  {
    text: "HUNGARY",
    age: 16,
    value: "HU"
  },
  {
    text: "INDONESIA",
    age: 18,
    value: "IN"
  },
  {
    text: "IRELAND",
    age: 18,
    value: "IE"
  },
  {
    text: "ISRAEL",
    age: 18,
    value: "IS"
  },
  {
    text: "ITALY",
    age: 14,
    value: "IT"
  },
 {
    text: "KAZAKHSTAN",
    age: 18,
    value: "KZ"
  },
  {
    text: "LUXEMBOURG",
    age: 16,
    value: "LU"
  },
  {
    text: "MONACO",
    age: 18,
    value: "MC"
  },
  {
    text: "NETHERLANDS",
    age: 16,
    value: "NL"
  },
  {
    text: "NORWAY",
    age: 13,
    value: "NO"
  },
  {
    text: "POLAND",
    age: 16,
    value: "PL"
  },
  {
    text: "PORTUGAL",
    age: 13,
    value: "PT"
  },
  {
    text: "ROMANIA",
    age: 16,
    value: "RO"
  },
  {
    text: "RUSSIA",
    age: 18,
    value: "RU"
  },
  {
    text: "SLOVENIA",
    age: 16,
    value: "SI"
  },
  {
    text: "SPAIN",
    age: 14,
    value: "ES"
  },
  {
    text: "SWEDEN",
    age: 13,
    value: "SE"
  },
  {
    text: "SWITZERLAND",
    age: 16,
    value: "CH"
  },
  {
    text: "TURKEY",
    age: 18,
    value: "TR"
  },
  {
    text: "UNITED KINGDOM",
    age: 13,
    value: "GB"
  },
  {
    text: "CANADA",
    age: 16,
    value: "CA"
  },
  {
    text: "UNITED STATES",
    age: 13,
    value: "US"
  },
  {
    text: "ARUBA",
    age: 18,
    value: "AW"
  },
  {
    text: "BRAZIL",
    age: 18,
    value: "BR"
  },
  {
    text: "CHILE",
    age: 18,
    value: "CL"
  },
  {
    text: "MEXICO",
    age: 18,
    value: "MX"
  },
  {
    text: "PANAMA",
    age: 18,
    value: "PA"
  },
  {
    text: "CHINESE MAINLAND",
    age: 14,
    value: "CN"
  },
  {
    text: "JAPAN",
    age: 16,
    value: "JP"
  },
  {
    text: "SOUTH KOREA",
    age: 14,
    value: "KR"
  },
  {
    text: "HONG KONG SAR",
    age: 18,
    value: "HK"
  },
  {
    text: "MACAU SAR",
    age: 19,
    value: "MO"
  },
  {
    text: "TAIWAN REGION",
    age: 20,
    value: "TW"
  },
  {
    text: "AUSTRALIA",
    age: 15,
    value: "AU"
  },
  {
    text: "GUAM",
    age: 18,
    value: "GU"
  },
  {
    text: "MALAYSIA",
    age: 18,
    value: "MY"
  },
  {
    text: "NEW ZEALAND",
    age: 18,
    value: "NZ"
  },
  {
    text: "PHILIPPINES",
    age: 18,
    value: "PH"
  },
  {
    text: "SINGAPORE",
    age: 13,
    value: "SG"
  },
  {
    text: "THAILAND",
    age: 20,
    value: "TH"
  },
  {
    text: "VIETNAM",
    age: 16,
    value: "VN"
  },
  {
    text: "BAHRAIN",
    age: 18,
    value: "BH"
  },
  {
    text: "INDIA",
    age: 18,
    value: "IN"
  },
  {
    text: "KUWAIT",
    age: 18,
    value: "KW"
  },
  {
    text: "QATAR",
    age: 18,
    value: "QA"
  },
  {
    text: "SAUDI ARABIA",
    age: 18,
    value: "SA"
  },
  {
    text: "SOUTH AFRICA",
    age: 18,
    value: "ZA"
  },
  {
    text: "UAE",
    age: 18,
    value: "AE"
  }
];